import { usePathname } from './usePathname';

export const useCurrentType = usePathname;
